import { createSelector } from '@reduxjs/toolkit';
import { ITimeFrame } from 'apis/types';
import { RootState } from 'app/store';
import { selectDisplayTimingGroups, selectTenpoInfo, selectTimeFrameLunch } from 'store/slices/mainSlice';
import { selectTime } from 'store/slices/timeSlice';
import { createDisplayTimingGroupResults, createDisplayTimingGroupSubmitResults } from 'utils/displayTimingGroup';
import { createMenuTimingContext } from 'utils/menuTimingContext';

const EMPTY_TIME_FRAMES: ITimeFrame[] = [];

const selectBusinessDate = (state: RootState): string => selectTime(state).business_date;
const selectBusinessTime = (state: RootState): string => selectTime(state).tm_hh_mm;
const selectHolidayFlag = (state: RootState): 0 | 1 | undefined => selectTime(state).is_holiday;
const selectTimeFrames = (state: RootState): ITimeFrame[] => selectTenpoInfo(state)?.time_frame ?? EMPTY_TIME_FRAMES;

export const selectMenuTimingContext = createSelector(
  [selectBusinessDate, selectBusinessTime, selectHolidayFlag, selectTimeFrames, selectTimeFrameLunch],
  (businessDate, businessTime, holidayFlag, timeFrames, lunchFrameIds) =>
    createMenuTimingContext(
      {
        business_date: businessDate,
        tm_hh_mm: businessTime,
        is_holiday: holidayFlag,
      },
      timeFrames,
      lunchFrameIds
    )
);

export const selectDisplayTimingGroupResults = createSelector(
  [selectDisplayTimingGroups, selectMenuTimingContext],
  (displayTimingGroups, context) =>
    context === null ? {} : createDisplayTimingGroupResults(displayTimingGroups, context)
);

export const selectDisplayTimingGroupSubmitResults = createSelector(
  [selectDisplayTimingGroups, selectMenuTimingContext, selectTimeFrames, selectTimeFrameLunch],
  (displayTimingGroups, context, timeFrames, lunchFrameIds) =>
    context === null
      ? {}
      : createDisplayTimingGroupSubmitResults(displayTimingGroups, context, timeFrames, lunchFrameIds)
);
